<template>
  <span>Loading...</span>
</template>

<script>

import userMixin from '@/mixins/user';

export default {
  mixins: [userMixin],
  created() {
    // From user mixin
    this.logout();
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/Logout.vue